export const CHECKOUT_SOURCE_PAGE = "checkoutSourcePage";
export const ACCESS_REDIRECT_URL = "urlToRedirect";
